import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as moment from "moment";
import classnames from "classnames";
import Select from "react-select";

import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  FormGroup,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getClubs,
  updateAlert,
  deleteAlert,
  getAlerts,
  setImage,
} from "store/actions";
import FileUpload from "components/FileUpload/FileUpload";
import DefaultModal from "components/Common/DefaultModal";

class AlertsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: [],
      alert: "",
      deleteModal: false,
      modal: false,
      clubId: null,
      club: "No Club Selected",
      clubError: false,
      dropdownOpen: false,
      activeClub: null,
      typeError: false,
      sendNotificationModal: false,
      hidden: false,
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      clubSelected: { label: "No Club Selected", value: "" },
      clubsOptions: [],
    };

    this.handleAlertClick = this.handleAlertClick.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickSendNotification = this.onClickSendNotification.bind(this);
  }

  handleClubSelect = club => {
    this.setState({
      clubSelected: club,
      activeClub: club.value,
    });
  };

  onClickSendNotification = alert => {
    this.setState({ alert });
    this.setState({ sendNotificationModal: true });
  };

  clubItemSelected(name, id) {
    this.setState({
      club: name,
      clubId: id,
      clubError: false,
    });
  }

  componentDidMount() {
    const { alerts, onGetClubs, clubs } = this.props;
    const authUser = localStorage.getItem("authUser");
    if (JSON.parse(authUser)?.clubId) {
      this.setState({
        activeClub: JSON.parse(authUser).clubId,
      });
    }
    if (clubs.length !== 0) {
      const authUser = localStorage.getItem("authUser");
      const club = this.props.clubs.find(
        item => item?.id === JSON.parse(authUser).clubId
      );
      if (club) {
        this.setState({
          clubsOptions: this.props.clubs.map(item => ({
            label: item.name,
            value: item.id,
          })),
          clubSelected: { label: club.name, value: club.id },
        });
      }
    } else {
      onGetClubs();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeClub } = this.state;
    const { onGetAlerts } = this.props;

    if (this.props.clubs !== prevProps.clubs) {
      const authUser = localStorage.getItem("authUser");
      const club = this.props.clubs.find(
        item => item?.id === JSON.parse(authUser).clubId
      );
      if (club) {
        this.setState({
          clubsOptions: this.props.clubs.map(item => ({
            label: item.name,
            value: item.id,
          })),
          clubSelected: { label: club.name, value: club.id },
        });
      }
    }
    if (activeClub !== prevState.activeClub) {
      if (activeClub) {
        onGetAlerts(activeClub);
      }
    }
  }

  onClickDelete = alert => {
    this.setState({ alert });
    this.setState({ deleteModal: true });
  };

  handleDeleteAlert = () => {
    const { onDeleteAlert, onGetAlerts } = this.props;
    const { alert, activeClub } = this.state;
    if (alert.id !== undefined) {
      onDeleteAlert(alert.id);
      this.setState({ deleteModal: false });
    }
    setTimeout(() => {
      onGetAlerts(activeClub);
    }, 1000);
  };

  handleAlertClick = arg => {
    const alert = arg;
    this.props.onSetImage(alert.image);

    this.setState({
      alert,
      isEdit: true,
      clubId: alert.club_id,
      club: this.props.clubs.find(item => item.id === alert.club_id)?.name,
      typeError: false,
    });
    this.toggle();
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  handleValidDate = date => {
    const date1 = moment(date).utc().format("DD MMM Y");
    return date1;
  };

  handleSendNotification = () => {
    const { onUpdateAlert } = this.props;
    const { alert } = this.state;
    const { clubId, title, description, image, expirationDate, id } = alert;
    this.props.onSetImage(image);

    if (alert.id !== undefined) {
      onUpdateAlert({
        id,
        title,
        description,
        clubId,
        expirationDate,
        sendPushNotification: true,
      });
      this.setState({ sendNotificationModal: false });
    }
  };

  render() {
    const { clubs, onUpdateAlert, loadingAlerts, alerts } = this.props;
    const { deleteModal, activeClub, alert } = this.state;
    const { SearchBar } = Search;
    const role = localStorage.getItem("roleId");

    const alertsColumns = [
      {
        dataField: "image",
        text: "#",
        // eslint-disable-next-line react/display-name
        formatter: (_, alert) => (
          <>
            <img src={alert.image} alt="" className="avatar-sm" />
          </>
        ),
      },
      {
        text: "Alert",
        dataField: "title",
      },
      {
        text: "Experation date",
        dataField: "title",
        // eslint-disable-next-line react/display-name
        formatter: (_, alert) => (
          <>
            <p
              style={{
                width: 300,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              className="text-muted mb-0"
            >
              {this.handleValidDate(alert.expirationDate)}
            </p>
          </>
        ),
      },

      {
        text: "Action",
        dataField: "",
        formatter: (_, alert) => (
          <>
            <UncontrolledDropdown>
              <DropdownToggle className="card-drop" tag="a">
                <i className="mdi mdi-dots-horizontal font-size-18" />
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  href="#"
                  onClick={() => this.onClickSendNotification(alert)}
                >
                  <i className="mdi mdi-send font-size-16 text-danger me-1" />{" "}
                  Send push notification
                </DropdownItem>
                <DropdownItem onClick={() => this.handleAlertClick(alert)}>
                  <i className="mdi mdi-pencil font-size-16 text-success me-1" />{" "}
                  Edit
                </DropdownItem>
                <DropdownItem onClick={() => this.onClickDelete(alert)}>
                  <i className="mdi mdi-trash-can font-size-16 text-danger me-1" />{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        ),
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: alerts?.length,
      custom: true,
    };

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteAlert}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />

        <DefaultModal
          title={"Are you sure you want to send a notification for this alert?"}
          description={"You will not be able to revert this!"}
          show={this.state.sendNotificationModal}
          onSendClick={this.handleSendNotification}
          onCloseClick={() => this.setState({ sendNotificationModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Alerts List | Groundfloor</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Alerts" breadcrumbItem="Alerts List" />
            <Row>
              <Col lg="12">
                <div className="">
                  <div className="table-responsive">
                    <Card>
                      <CardBody>
                        {this.state.isMobile ? (
                          <Row>
                            <Col lg="1">
                              <div style={{ marginBottom: 10 }}>
                                <Link to="/add-app-alerts">
                                  <Button
                                    // color="#032224"
                                    style={{ backgroundColor: "#032224" }}
                                    className="font-16 btn-block btn btn-primary"
                                  >
                                    <i className="mdi mdi-plus-circle-outline me-1" />
                                    Add alert
                                  </Button>
                                </Link>
                              </div>
                              <Select
                                styles={{}}
                                onChange={this.handleClubSelect}
                                options={this.state.clubsOptions}
                                value={this.state.clubSelected}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                          </Row>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Nav
                              pills
                              className="bg-light rounded"
                              role="tablist"
                            >
                              <NavItem></NavItem>
                              {clubs?.map((item, index) => (
                                <NavItem key={index}>
                                  <NavLink
                                    className={classnames({
                                      active: activeClub === item.id,
                                    })}
                                    style={{
                                      backgroundColor:
                                        activeClub === item.id
                                          ? "#032224"
                                          : "transparent",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        activeClub: item.id,
                                      });
                                    }}
                                  >
                                    {item.name}
                                  </NavLink>
                                </NavItem>
                              ))}
                            </Nav>
                            <div className="text-sm-end">
                              <Link to="/add-app-alerts">
                                <Button
                                  // color="#032224"
                                  style={{ backgroundColor: "#032224" }}
                                  className="font-16 btn-block btn btn-primary"
                                >
                                  <i className="mdi mdi-plus-circle-outline me-1" />
                                  Add alert
                                </Button>
                              </Link>
                            </div>
                          </div>
                        )}
                        {alerts && (
                          <PaginationProvider
                            pagination={paginationFactory(pageOptions)}
                            columns={alertsColumns}
                            data={alerts}
                          >
                            {({ paginationProps, paginationTableProps }) => (
                              <ToolkitProvider
                                keyField="id"
                                columns={alertsColumns}
                                data={alerts}
                              >
                                {toolkitProps => (
                                  <React.Fragment>
                                    <Row>
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                        style={{ marginTop: 10 }}
                                      />
                                      <Col xl="12">
                                        <div className="table-responsive">
                                          {loadingAlerts ? (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Link
                                                to="#"
                                                className="text-success"
                                              >
                                                <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" />{" "}
                                                Loading
                                              </Link>{" "}
                                            </div>
                                          ) : (
                                            <BootstrapTable
                                              responsive
                                              bordered={false}
                                              striped={false}
                                              classes={
                                                "table align-middle table-nowrap"
                                              }
                                              headerWrapperClasses={
                                                "thead-light"
                                              }
                                              {...toolkitProps.baseProps}
                                              {...paginationTableProps}
                                            />
                                          )}
                                        </div>
                                      </Col>
                                      {/* </Link> */}
                                    </Row>

                                    <Row className="align-items-md-center mt-30">
                                      <Col className="inner-custom-pagination d-flex">
                                        <div className="d-inline">
                                          <SizePerPageDropdownStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                        <div className="text-md-right ms-auto">
                                          <PaginationListStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </React.Fragment>
                                )}
                              </ToolkitProvider>
                            )}
                          </PaginationProvider>
                        )}
                      </CardBody>
                    </Card>
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {"Edit Alert"}
                      </ModalHeader>
                      <ModalBody>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            title: (alert && alert.title) || "",
                            description: (alert && alert.description) || "",
                            expirationDate:
                              (alert &&
                                moment(alert?.expirationDate)
                                  .utc()
                                  .format("YYYY-MM-DD")) ||
                              "",
                          }}
                          validationSchema={Yup.object().shape({
                            title: Yup.string().required("Please Enter Title"),
                            description: Yup.string().required(
                              "Please Enter Description"
                            ),
                            expirationDate: Yup.string().required(
                              "Please Enter Expiration Date"
                            ),
                          })}
                          onSubmit={values => {
                            const updateAlert = {
                              description: values.description,
                              clubId: this.state.alert.clubId,
                              id: alert.id,
                              title: values.title,
                              expirationDate: moment(
                                values.expirationDate
                              ).format("YYYY-MM-DD"),
                            };
                            onUpdateAlert(updateAlert);
                            this.toggle();
                            setTimeout(() => {
                              this.props.onGetAlerts(activeClub);
                            }, 500);
                          }}
                        >
                          {({ errors, status, touched }) => (
                            <Form>
                              <Row>
                                <Col className="col-12">
                                  <div className="mb-3">
                                    <Field name="img" type="hidden" />
                                  </div>
                                  <div className="mb-3">
                                    <Field name="team" type="hidden" />
                                  </div>
                                  <div className="mb-3">
                                    <Label className="form-label">Title</Label>
                                    <Field
                                      name="title"
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.title && touched.title
                                          ? " is-invalid"
                                          : "")
                                      }
                                    />
                                    <ErrorMessage
                                      name="title"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                  <div className="mb-3">
                                    <Label className="form-label">
                                      Expiration Date
                                    </Label>
                                    <Field
                                      name="expirationDate"
                                      type="date"
                                      className={
                                        "form-control" +
                                        (errors.expirationDate &&
                                        touched.expirationDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                    />
                                    <ErrorMessage
                                      name="expirationDate"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                  <div className="mb-3">
                                    <Label className="form-label">
                                      Description
                                    </Label>
                                    <Field
                                      name="description"
                                      type="text"
                                      component="textarea"
                                      rows="6"
                                      className={
                                        "form-control" +
                                        (errors.description &&
                                        touched.description
                                          ? " is-invalid"
                                          : "")
                                      }
                                    />
                                    <ErrorMessage
                                      name="description"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </div>
                                  <FormGroup className="mb-3" row>
                                    <Label className="col-form-label col-lg-2">
                                      Attach Image
                                    </Label>
                                    <Col lg="10">
                                      <FileUpload />
                                    </Col>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className="text-end">
                                    <button
                                      type="submit"
                                      className="btn btn-success save-user"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AlertsList.propTypes = {
  alerts: PropTypes.array,
  className: PropTypes.any,
  onUpdateAlert: PropTypes.func,
  onSetImage: PropTypes.func,
  onDeleteAlert: PropTypes.func,
  onGetAlerts: PropTypes.func,
  onGetClubs: PropTypes.func,
  loadingAlerts: PropTypes.bool,
  clubs: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

const mapStateToProps = ({ alerts, system }) => ({
  alerts: alerts.alerts,
  loadingAlerts: alerts.loadingAlerts,
  clubs: system.clubs,
});

const mapDispatchToProps = dispatch => ({
  onGetClubs: () => dispatch(getClubs()),
  onUpdateAlert: alert => dispatch(updateAlert(alert)),
  onDeleteAlert: id => dispatch(deleteAlert(id)),
  onGetAlerts: clubId => dispatch(getAlerts(clubId)),
  onSetImage: image => dispatch(setImage(image)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AlertsList));
